import React, {useEffect, useState} from 'react'
import SlidePanel from "../../../components/layout/slide-panel";
import {useTranslation} from "react-i18next";
import {
    getEmailsParams,
    getGenericAttachmentsParams,
    getSelectParams,
    getWebPathParam
} from "../../../utils/converter";
import {Controller, useForm} from "react-hook-form";
import InputSelect from "../../common/form/input-select";
import InputSelectInsert from "../../common/form/input-select-insert";
import {emailRegex} from "../../../constants/regex";
import InputText from "../../common/form/input-text";
import {getCompanyMailList, getCompanyMails, getSendCompanyMail} from "../../../api/company";
import {useSelector} from "react-redux";
import ButtonSubmit from "../../common/form/button-submit";
import {ATTACHMENT} from "../../../constants/config";
import InputEmailEditor from "../../common/form/input-email-editor";
import {Warning} from "../../common/alert/banner";
import toast from "react-hot-toast";
import {Link} from "react-router-dom";
import {
    COMPANY,
    CONFIGURATION,
    EMAIL_INTEGRATION
} from "../../../routes/endpoints";
import UploadMultifile from "../upload/upload-multifile";

const GenericEmailSender = ({isOpen, setIsOpen, entityType, entityNote, entityId, baseAttachments = [], baseEmail = [], baseTitle }) => {

    const { t } = useTranslation();
    const { loggedCompany } = useSelector((state) => state.user);

    const [isLoadingEmails, setLoadingEmails] = useState(true);
    const [defaultEmails, setDefaultEmails] = useState([]);
    const [isLoadingCompanyEmails, setLoadingCompanyEmails] = useState(true);
    const [companyEmails, setCompanyEmails] = useState([]);



    const [isSendingMail, setSendingMail] = useState(false);
    const [exception, setException] = useState(false);

    const [attachments, setAttachments] = useState([]);
    const [files, setFiles] = useState([]);

    const [selectedAttachments, setSelectedAttachments] = useState([]);


    const {
        register,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm({ mode: "onBlur" });


    const clean = () =>{
        setSelectedAttachments([]);
        setException(false);
        setValue('mail_provider', null);
        setValue('recipients', null);
        setValue('content', null);
        setValue('subject', null);
    };

    useEffect(() => {
        async function fetchEmails() {
            if (isOpen) {
                setLoadingEmails(true);
                setDefaultEmails([]);
                try {
                    const eMails = await getCompanyMailList({company_id: loggedCompany.id});
                    let list = [];

                    if(baseEmail.length > 0){
                        list.push({ label: baseTitle, options: getEmailsParams(baseEmail, "email")});

                    }

                    if((eMails?.employees ?? []).length > 0){
                        list.push({ label: 'Staff', options: getEmailsParams(eMails.employees, "email")});
                    }

                    if((eMails?.agents ?? []).length > 0){
                        list.push({ label: t("app.common.agents"), options: getEmailsParams(eMails.agents, "email")});
                    }

                    setDefaultEmails(list);

                } catch (e) {
                    setDefaultEmails([]);
                } finally {
                    setLoadingEmails(false);
                }
            }
        }

        fetchEmails();

        // eslint-disable-next-line
    }, [isOpen, loggedCompany]);


    useEffect(() => {
        function fetchCompanyEmails() {
            if (loggedCompany && isOpen) {
                setLoadingCompanyEmails(true);
                getCompanyMails({company_id:  loggedCompany.id, params: {filter_by: 'active'}})
                    .then((response) => {
                        setCompanyEmails(getSelectParams(response, "email"));
                        setLoadingCompanyEmails(false);
                    }).catch((e) => {
                        setCompanyEmails([]);
                        setLoadingCompanyEmails(true);
                    });
            }
        }

        fetchCompanyEmails();

    }, [isOpen, loggedCompany]);


    useEffect(() => {
        if (baseAttachments.length > 0) {
            setAttachments(getGenericAttachmentsParams(baseAttachments));
        }
    }, [baseAttachments]);



    const checkIfCanSend =  ()  => {
        if(watch('recipients') && watch('recipients').length === 0){
            return false;
        }

        if(watch('subject') && watch('subject').length === 0){
            return false;
        }

        return true;
    };

    const sendMail = async ()  => {
        setSendingMail(true);



        let sendAttachments = [];
        // eslint-disable-next-line
        selectedAttachments.map(a => {
            sendAttachments.push({name: a.name, file: a.data.file.reference})
        })

        // eslint-disable-next-line
        files.map(a => {
            sendAttachments.push({name: a.name, file: a.media_url})
        })

        let recipients = [];
        // eslint-disable-next-line
        watch('recipients').map(a => {
            recipients.push({full_name: a.full_name, email: a.email})
        })





        let data = {
            attachments: sendAttachments,
            recipients: recipients,
            content: watch('content'),
            subject: watch('subject'),
            entity_type: entityType,
            entity_note: entityNote,
            entity_id: entityId,
        };


       if(loggedCompany){
           setException(false);
           getSendCompanyMail({company_id: loggedCompany.id, email_id: watch('mail_provider').id,  data})
                    .then(response => {
                        setSendingMail(false);
                        toast.success(t("app.provider.send_success"));
                        clean();
                        setIsOpen(false);
             }).catch(e => {
              setException(e.message);
              setSendingMail(false);
          });
      }
    };



    return (
        <>
            <SlidePanel
                title={t("app.leads.email_description")}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                bg={'bg-white'}
                size={'max-w-2xl'}
                footer={Footer}
                setClean={() => {
                    clean();
                }}
                extras={{
                    isSendingMail,
                    isActiveSendMail: checkIfCanSend(),
                    onSubmit: () => {
                        sendMail();
                    }
                }}
            >
                <div className="space-y-6 pt-6 pb-5 mb-8">

                    <div>
                        <Controller
                            name="mail_provider"
                            rules={{ required: true }}
                            control={control}
                            render={({
                                         field: { onChange, value, name },
                                         fieldState: { error },
                                     }) => (
                                <InputSelect
                                    label={t("app.provider.email_from")}
                                    name={name}
                                    onChange={(e) => {
                                        if(e.email_footer){
                                            setValue('content',  e.email_footer)
                                        }
                                        onChange(e);
                                    }}
                                    options={companyEmails}
                                    value={value}
                                    isLoading={isLoadingCompanyEmails}
                                    isDisabled={isLoadingCompanyEmails}
                                    errors={error}
                                />
                            )}
                        />
                        <div className={"flex justify-between before:flex-1"}>
                            <Link to={getWebPathParam([COMPANY, CONFIGURATION, EMAIL_INTEGRATION])} className="mt-1 flex items-center text-xs text-indigo-600 underline cursor-pointer">
                                {t("app.provider.add_name")}
                            </Link>
                        </div>
                    </div>

                    <Controller
                        name="recipients"
                        rules={{ required: true }}
                        control={control}
                        render={({
                                     field: { onChange, value, name },
                                     fieldState: { error },
                                 }) => (
                            <InputSelectInsert
                                label={t("app.provider.email_recipient")}
                                name={name}
                                onChange={(e) => {
                                    onChange(e);
                                }}
                                regex={emailRegex}
                                onCreateOption={(e) => {
                                    let dataGroup = defaultEmails.find(r => r.label === 'Customs');
                                    let foundIndex = defaultEmails.findIndex(x => x.label === 'Customs');
                                    if(dataGroup){
                                        defaultEmails[foundIndex]['options'].push(e);
                                    }else{
                                        setDefaultEmails((prev) => [...prev, { label: 'Customs', options: [e]}]);

                                    }
                                    if(watch('recipients')){
                                        setValue('recipients', [...watch('recipients'), e])
                                    }else{
                                        setValue('recipients', [e])
                                    }

                                }}
                                options={defaultEmails}
                                value={value}
                                isMulti={true}
                                isClearable={true}
                                isLoading={isLoadingEmails}
                                isDisabled={isLoadingEmails}
                                errors={error}
                            />
                        )}
                    />


                    {
                        attachments.filter(
                            (c) =>
                                !selectedAttachments
                                    .map((c) => c.id)
                                    .includes(c.id)
                        ).length > 0 ? (
                            <Controller
                                name="attachments"
                                rules={{ required: true }}
                                control={control}
                                render={({
                                             field: { onChange, value, name },
                                             fieldState: { error },
                                         }) => (
                                    <InputSelect
                                        label={t("app.provider.attachments")}
                                        customOption={ATTACHMENT}
                                        name={name}
                                        onChange={(e) => {
                                            onChange(e);
                                            setSelectedAttachments((prev) => [...prev, e]);
                                            setValue('attachments', null)
                                        }}
                                        options={attachments.filter(
                                            (c) =>
                                                !selectedAttachments
                                                    .map((c) => c.id)
                                                    .includes(c.id)
                                        )}
                                        value={value}
                                        isLoading={false}
                                        isDisabled={false}
                                        errors={error}
                                    />
                                )}
                            />
                        ) : (
                            <label className="block text-sm font-medium mb-1 text-gray-700 -mb-3">
                                {t("app.provider.attachments")}
                            </label>
                        )
                    }

                    <div className={'col-span-2'}>
                        <UploadMultifile
                            onUpload={(data) => {
                                setFiles(data);
                            }}
                            onException={(e) => setException(e)}
                            isLoading={false}
                            genericDocuments={selectedAttachments}
                            onRemoveGeneric={(id) => (
                                setSelectedAttachments(selectedAttachments.filter(function( obj ) {
                                    return obj.id !== id;
                                }))
                            )}
                        />
                    </div>


                    <InputText
                        id={'subject'}
                        type={'text'}
                        errors={errors.subject}
                        input={{...register("subject", { required: true })}}
                        label={t("app.provider.subject")}
                    />

                    <Controller
                        name="content"
                        rules={{ required: false }}
                        control={control}
                        render={({field: { onChange, value, name },
                                     fieldState: { error },
                                 }) => (
                            <InputEmailEditor
                                label={t("app.provider.message")}
                                errors={error}
                                defaultValue={value}
                                className={"h-64"}
                                name={name}
                                onChange={(e) => {
                                    onChange(e);
                                }}
                            />
                        )}
                    />








                </div>


                {/* Warning */}
                {exception && (
                    <Warning message={exception} />
                )}
            </SlidePanel>


        </>

    );
};

const Footer = ({extras}) => {
    const { t } = useTranslation();

    return (
        <div className="flex-shrink-0 before:flex-1 px-4 py-4 flex justify-between">
            <ButtonSubmit
                isLoading={extras.isSendingMail}
                label={t("app.provider.send_mail")}
                isFullWith={true}
                onClick={() => {
                    extras.onSubmit()
                }}
                disabled={!extras.isActiveSendMail}
            />
        </div>
    );

};






export default GenericEmailSender;
